import * as React from 'react';

import { ESuburbanOfferFilter } from '../../../types/jsonQuery';
import { getTermValue } from '../../../../../JsonQuery';
import { useContext } from '../../../utils/useContext';
import { Posessor } from '../../../components/filters/Posessor';

export const PosessorContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const posessorType = getTermValue('suburban_offer_filter')(jsonQuery);

  const handleChange = React.useCallback(
    (posessorType: ESuburbanOfferFilter | null) => {
      onChange({ action: 'setPosessor', arguments: [posessorType] });
    },
    [onChange],
  );

  return <Posessor value={posessorType} onChange={handleChange} />;
};
